import PythonRecommended from "../../components/Ai_Comp/pythonRecommended";
import PythonSyllabus from "../../components/Ai_Comp/PythonSyllabus";
import GetInTouch from "../../components/common/Contact/GetInTouch";
import CourseFAQ from "../../components/common/CourseFAQ/CourseFAQ";
import CourseHeroSection from "../../components/common/CourseHero/CourseHeroSection";
import CourseReasons from "../../components/common/CourseReasons/CourseReasons";
import PlaceMentRecord from "../../components/common/PlaceMent/PlaceMentRecord";
import ScrollText from "../../components/common/ScrollText/ScrollText";
import SEO from "../../components/common/seo/SEO";
import { pythonFaqs } from "../../data/ai_section/pythonFaqData";
import pythonReasons from "../../data/ai_section/pythonReasons";




const pythonFeatures = [
    "Learn Python Online from experts working in top tech companies.",
    "Learn Python from scratch or only the portion that matters to you.",
    "Job Assistance, Career Support, and Mock Interviews.",
    "Real-world, hands-on projects to build your portfolio.",
    "Industry-recognized certifications.",
];


function PythonPage() {

    return (
        <>
            <SEO title="Python Course Online | Python Training | FeesWorth"
                description="Learn Python online through practical, industry-focused training. Build real-world Python skills, work on hands-on projects, and get career support from experienced professionals."
                keywords="Python Course, Python Training, Python Course Online, Python Classes, Learn Python, Python Certification Course, Python Programming Course, Python Online Training, Python Projects"
                canonical="https://feesworth.com/python-courses-pay-after-learn" />

            <CourseHeroSection
                badge="PYTHON TRAINING"
                title="Python Course"
                titleHighlight="Online"
                logo="/Python_Logo.webp"
                logoAlt="Python Logo"
                description="Master Python with practical, industry-focused training designed to help you build real-world skills and advance your career."
                features={pythonFeatures}
            />


            <ScrollText />


            <CourseReasons
                courseName="Python"
                reasons={pythonReasons}
            />


            <PlaceMentRecord />


            <PythonSyllabus />


            <PythonRecommended />


            <CourseFAQ
                courseName="Python"
                faqs={pythonFaqs}
            />


            <GetInTouch
                courseName="Python"
            />

        </>
    );
}

export default PythonPage;